var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.palette)?_c('div',{staticClass:"code-view "},[_c('active-palette'),_vm._v(" "),_c('div',{staticClass:"gutter frame fade-in-up"},[_c('code-component',{attrs:{"palette":_vm.palette}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }